// @flow
import type { RawClassicType } from 'types/GraphQL';

export const RESET_SEASON = 'RESET_SEASON';
export const FETCH_SEASON_START = 'FETCH_SEASON_START';
export const FETCH_SEASON_SUCCESS = 'FETCH_SEASON_SUCCESS';
export const FETCH_SEASON_FAILURE = 'FETCH_SEASON_FAILURE';

export type RESET_SEASON_ACTION = {
  type: 'RESET_SEASON',
};

export type FETCH_SEASON_START_ACTION = {
  type: 'FETCH_SEASON_START',
};

export type FETCH_SEASON_SUCCESS_ACTION = {
  type: 'FETCH_SEASON_SUCCESS',
  payload: {
    seasons: { seasons: RawClassicType[], lastSeason: RawClassicType }
  }
};

export type FETCH_SEASON_FAILURE_ACTION = {
  type: 'FETCH_SEASON_FAILURE'
};

export type Action =
  | RESET_SEASON_ACTION
  | FETCH_SEASON_START_ACTION
  | FETCH_SEASON_SUCCESS_ACTION
  | FETCH_SEASON_FAILURE_ACTION;

export const resetSeason = (): RESET_SEASON_ACTION => {
  return {
    type: RESET_SEASON,
  };
};

export const fetchSeason = (): FETCH_SEASON_START_ACTION => {
  return {
    type: FETCH_SEASON_START,
  };
};

export const seasonsFetched = (
  seasons: { seasons: RawClassicType[], lastSeason: RawClassicType }
): FETCH_SEASON_SUCCESS_ACTION => {
  return {
    type: FETCH_SEASON_SUCCESS,
    payload: { seasons }
  };
};

export const seasonsFetchError = (error: any): FETCH_SEASON_FAILURE_ACTION => {
  return {
    type: FETCH_SEASON_FAILURE,
    payload: { error }
  };
};
